import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Patterns, IconButton, Tooltip } from '@treezor/design-system';

import { JsonViewer } from '../json-viewer/JsonViewer';

interface IToastMessageProps {
  message: string;
  documentation?: string;
  payload?: object;
}

export const ToastMessage = ({ message, documentation, payload }: IToastMessageProps) => {
  const { t } = useTranslation();

  const [isExpand, setIsExpand] = useState(false);

  const openTreezorDocumentation = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    window.open(documentation?.match(Patterns.url) ? documentation : 'https://docs.treezor.com/', '_blank');
  };

  const handleErrorExpand = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setIsExpand((expand) => !expand);
  };

  return (
    <div className="flex flex-col" data-testid="toast-error">
      <div className="flex items-center justify-between text-center">
        <div>
          {message}
          {payload && ' - '}
          {payload && (
            <span className="underline" onClick={handleErrorExpand}>
              {isExpand ? t('layout.notification.less') : t('layout.notification.more')}
            </span>
          )}
        </div>

        {documentation && (
          <Tooltip messageContent={t('layout.notification.openDocumentation')}>
            <IconButton size="s" icon="quiz" onClick={openTreezorDocumentation} />
          </Tooltip>
        )}
      </div>

      {payload && isExpand && (
        <div
          className="overflow-auto bg-primary m-3 max-h-[50rem]"
          onClick={(e: MouseEvent<HTMLDivElement>) => e.stopPropagation()}
        >
          <JsonViewer src={payload} />
        </div>
      )}
    </div>
  );
};
